import { NavFooter } from '@/components/nav-footer';
import { NavMain } from '@/components/nav-main';
import { NavUser } from '@/components/nav-user';
import { Sidebar, SidebarContent, SidebarFooter, SidebarHeader, SidebarMenu, SidebarMenuButton, SidebarMenuItem } from '@/components/ui/sidebar';
import { home as dashboard } from '@/routes/dashboard';
import { index as myFavorites } from '@/routes/dashboard/favorites';
import { edit as profileEdit } from '@/routes/profile';
import { type NavItem, type SharedData } from '@/types';
import { Link, usePage } from '@inertiajs/react';
import { Heart, LayoutGrid, Settings } from 'lucide-react';
import AppLogo from './app-logo';

// CN-191 etapa 3c: the user area has no administrative item any more; the admin reaches the management
// screens through the "Admin" item of the user menu (/admin).
const allNavItems: NavItem[] = [
    {
        title: 'Dashboard',
        href: dashboard(),
        icon: LayoutGrid,
        roles: ['admin', 'basic'], // Admins and basic users can access, sponsors cannot
    },
    {
        title: 'Favoritos',
        href: myFavorites(),
        icon: Heart,
        roles: ['admin', 'sponsor', 'basic'], // All roles can access
    },
];

const footerNavItems: NavItem[] = [];

export function AppSidebar({ hideOnLarge = false }: { hideOnLarge?: boolean }) {
    const page = usePage<SharedData>();
    const user = page.props.auth?.user;
    const userRole = user?.role || 'basic';

    // Filter nav items based on user role
    const mainNavItems = allNavItems.filter((item) => {
        if (!item.roles) {
            return true; // If no roles specified, show to everyone
        }
        return item.roles.includes(userRole);
    });

    // Show settings only to admins
    const showSettings = userRole === 'admin';

    return (
        <Sidebar hideOnLarge={hideOnLarge} collapsible="icon" variant="inset">
            <SidebarHeader>
                <SidebarMenu>
                    <SidebarMenuItem>
                        <SidebarMenuButton size="lg" asChild>
                            <Link href={dashboard()} prefetch>
                                <AppLogo />
                            </Link>
                        </SidebarMenuButton>
                    </SidebarMenuItem>
                </SidebarMenu>
            </SidebarHeader>

            <SidebarContent>
                <NavMain items={mainNavItems} />
                {showSettings && (
                    <SidebarMenu>
                        <SidebarMenuItem>
                            <SidebarMenuButton asChild tooltip={{ children: 'Configurações' }}>
                                <Link href={profileEdit()} prefetch>
                                    <Settings />
                                    <span>Configurações</span>
                                </Link>
                            </SidebarMenuButton>
                        </SidebarMenuItem>
                    </SidebarMenu>
                )}
            </SidebarContent>

            <SidebarFooter>
                <NavFooter items={footerNavItems} className="mt-auto" />
                <NavUser />
            </SidebarFooter>
        </Sidebar>
    );
}
